import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// PURCHASE REMARKS AND PO DETAILS RELATED APIs
// ==============================================

// 1. Get Remarks by Transaction Number and MO ID
export const getRemarks = async (trno, moid) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/Remarks?Trno=${trno}&MOID=${moid}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Previous PO Details by Item Code
export const getPreviousPODetails = async (itemcode) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetPreviousePODetails?Itemcode=${itemcode}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};